export default {
  data() {
    return {
      isPOCAlsoTenantManager: false
    };
  },
  watch: {
    'entity.contactEmail'(contactEmail) {
      this.syncPOCEmailWithTenantManagerEmail(contactEmail);
      this.checkIsPOCAlsoTenantManager();
    },
    'entity.contactName'(contactName) {
      this.syncPOCNameWithTenantManagerName(contactName);
      this.checkIsPOCAlsoTenantManager();
    },
    'entity.tenantManagerEmail'(tenantManagerEmail) {
      this.syncPOCEmailWithTenantManagerEmail(tenantManagerEmail);
      this.checkIsPOCAlsoTenantManager();
    },
    'entity.tenantManagerName'(tenantManagerName) {
      this.syncPOCNameWithTenantManagerName(tenantManagerName);
      this.checkIsPOCAlsoTenantManager();
    }
  },
  methods: {
    onSelectIsTenantManager(event) {
      this.isPOCAlsoTenantManager = event.target.checked;
      this.syncPOCNameWithTenantManagerName(this.entity.contactName);
      this.syncPOCEmailWithTenantManagerEmail(this.entity.contactEmail);
    },
    syncPOCEmailWithTenantManagerEmail(email) {
      if (!this.isPOCAlsoTenantManager) return;
      this.entity = {
        ...this.entity,
        contactEmail: email,
        tenantManagerEmail: email
      };
    },
    syncPOCNameWithTenantManagerName(name) {
      if (!this.isPOCAlsoTenantManager) return;
      this.entity = {
        ...this.entity,
        contactName: name,
        tenantManagerName: name
      };
    },
    checkIsPOCAlsoTenantManager() {
      const {
        contactEmail,
        contactName,
        tenantManagerEmail,
        tenantManagerName
      } = this.entity || {};

      if (
        !contactEmail?.trim() ||
        !contactName?.trim() ||
        !tenantManagerEmail?.trim() ||
        !tenantManagerName?.trim()
      )
        return;

      if (
        contactEmail !== tenantManagerEmail ||
        contactName !== tenantManagerName
      )
        return;

      this.isPOCAlsoTenantManager = true;
    }
  }
};
